import '../App.css';
export default function NavigationPreloadManager(){
    return(
        <div className="nav">
            <div className="flex">
                <header>💱Change Exchange💱</header>
            </div>
        </div>
    );
}